import { render, staticRenderFns } from "./variant-thumb.vue?vue&type=template&id=628534ae&"
import script from "./variant-thumb.vue?vue&type=script&lang=js&"
export * from "./variant-thumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports